import DisplayItem from './DisplayItem';
import Section from './Section';
import { v4 as uuid } from 'uuid';
import Test from './Test';
class InstructionalItem implements DisplayItem {
  private readonly _section: Section;
  private readonly _qti: string;
  private _currentItem = false;
  private readonly _identifier: string;
  constructor(section: Section, qti: string) {
    this._section = section;
    this._qti = qti;
    this._identifier = uuid();
  }
  get state(): string {
    return '';
  }
  set state(value: string) {
    // Do nothing
  }

  get identifier(): string {
    return this._identifier;
  }

  get section(): Section {
    return this._section;
  }

  get qti(): string {
    return '<div style="padding-left: 20px; padding-right: 20px;" >' + this._qti + '</div>';
  }

  get currentItem(): boolean {
    return this._currentItem;
  }

  set currentItem(value: boolean) {
    this._currentItem = value;
    // Set first item of this section to the current.
    if (value && this.section.items.length > 0) {
      this.section.items[0].currentItem = true;
      this.section.testPart.test.locationState = Test.SECTION_INSTRUCTIONS_STATE;
    }
  }

  getItemTitle(): string {
    const i18n = (window as any).i18n.global;
    return i18n.t('common.instructions');
  }

  getPercentage(): number {
    return 0;
  }
}

export default InstructionalItem;
